/* Maquininhas de cartão — calculadora de taxas do PDV (Caixa) e da
   Calculadora de preço. Não faz nenhuma integração automática com a
   maquininha: só calcula quanto cobrar do CLIENTE pra que a taxa da
   maquininha saia do valor cobrado, e não do bolso do vendedor.

   Crédito tem uma taxa por número de parcelas (1x a 12x — quanto mais
   parcelas, maior a taxa), guardada em `credito` como array de 12
   posições (índice 0 = 1x, índice 11 = 12x). Débito é uma taxa única.

   As taxas são só uma referência inicial (variam por faturamento/negociação
   de cada conta) — ficam editáveis em Configurações → Pagamentos, e o
   vendedor deve conferir a taxa real no app da própria maquininha. */
export const MAX_PARCELAS = 12;

export const MAQUININHAS_PADRAO = [
  { id: "mp", nome: "Mercado Pago", debito: 1.99,
    credito: [4.98, 9.90, 11.17, 12.44, 13.71, 14.98, 16.24, 17.51, 18.78, 20.05, 21.32, 22.59] },
  { id: "inf", nome: "InfinitePay", debito: 0.75,
    credito: [3.15, 3.49, 4.89, 4.89, 4.89, 4.89, 6.99, 6.99, 6.99, 6.99, 6.99, 6.99] },
];

export function listaMaquininhas(cfg) {
  return (cfg?.maquininhas && cfg.maquininhas.length) ? cfg.maquininhas : MAQUININHAS_PADRAO;
}

/* modalidade = "debito" ou um número de 1 a 12 (quantidade de parcelas do
   crédito). Aceita o formato antigo (`credito1x` solto, de antes de existir
   parcelamento) como fallback pra quem já tinha salvo maquininha customizada. */
export function taxaMaquininha(maquininha, modalidade) {
  if (!maquininha) return 0;
  if (modalidade === "debito") return Number(maquininha.debito) || 0;
  const n = Math.max(1, Math.min(MAX_PARCELAS, Number(modalidade) || 1));
  if (Array.isArray(maquininha.credito) && maquininha.credito.length) {
    return Number(maquininha.credito[n - 1]) || 0;
  }
  return Number(maquininha.credito1x) || 0; // compat com config salva antes do parcelamento
}

/* valorDesejado = quanto o vendedor quer receber líquido (o valor da venda).
   Repassa a taxa da maquininha pro cliente: calcula quanto precisa ser
   COBRADO no cartão pra que, depois de descontada a taxa, sobre exatamente
   valorDesejado pro vendedor — em vez da taxa sair do bolso dele.
   Retorna { acrescimo, valorCobrar }. */
export function calcularRepasse(valorDesejado, taxaPct) {
  const taxa = Math.max(0, Number(taxaPct) || 0) / 100;
  const valorCobrar = taxa < 1 ? valorDesejado / (1 - taxa) : valorDesejado;
  return { acrescimo: Math.max(0, valorCobrar - valorDesejado), valorCobrar };
}
